import { render, staticRenderFns } from "./CustomizePlatform.vue?vue&type=template&id=7d9db8eb&scoped=true&"
import script from "./CustomizePlatform.vue?vue&type=script&lang=js&"
export * from "./CustomizePlatform.vue?vue&type=script&lang=js&"
import style0 from "./CustomizePlatform.vue?vue&type=style&index=0&id=7d9db8eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9db8eb",
  null
  
)

export default component.exports